import { InfoTooltip } from "@iventis/components";
import { Theme } from "@emotion/react";
import { Body1, popoverPadding, SolidButton, TextButton } from "@iventis/styles";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import React, { FunctionComponent, ReactElement, useEffect } from "react";
import { useTheme } from "@mui/material";

export enum tooltipStages {
    SET_SAVE,
    SAVE_INFO,
    NONE,
}

export const MapNavigationTooltip: FunctionComponent<{
    children: ReactElement<unknown>;
    showTooltip: boolean;
    onClose: () => void;
    onSave: () => void;
}> = ({ children, showTooltip, onClose, onSave }) => {
    const translate = useIventisTranslate();
    const theme = useTheme<Theme>();

    const [tooltipStage, setTooltipStage] = React.useState(tooltipStages.NONE);

    useEffect(() => {
        if (showTooltip) {
            setTooltipStage(tooltipStages.SET_SAVE);
        } else {
            setTooltipStage(tooltipStages.NONE);
        }
    }, [showTooltip]);

    if (showTooltip) {
        if (tooltipStage === tooltipStages.SET_SAVE) {
            return (
                <InfoTooltip
                    title={translate(Content.map3.search_tooltip.set_save_title)}
                    text={
                        <div style={{ display: "flex", flexDirection: "column", gap: popoverPadding.standard }}>
                            <Body1 style={{ textAlign: "left" }}>{translate(Content.map3.search_tooltip.set_save_content)}</Body1>
                            <div style={{ display: "flex" }}>
                                <TextButton
                                    style={{ width: "100%", color: theme.typographyColors.primary }}
                                    onClick={() => {
                                        setTooltipStage(tooltipStages.SAVE_INFO);
                                    }}
                                    data-testid="dismiss-default-location-prompt"
                                >
                                    {Content.map3.search_tooltip.set_save_dismiss}
                                </TextButton>
                                <SolidButton
                                    data-testid="save-default-location-button"
                                    style={{ width: "100%" }}
                                    onClick={() => {
                                        onSave();
                                        setTooltipStage(tooltipStages.SAVE_INFO);
                                    }}
                                >
                                    {Content.map3.search_tooltip.set_save_save}
                                </SolidButton>
                            </div>
                        </div>
                    }
                    open
                    onClose={() => {
                        setTooltipStage(tooltipStages.SAVE_INFO);
                    }}
                    testId="set-save-tooltip"
                >
                    {children}
                </InfoTooltip>
            );
        }
        if (tooltipStage === tooltipStages.SAVE_INFO) {
            return (
                <InfoTooltip
                    title={translate(Content.map3.search_tooltip.save_info_title)}
                    text={
                        <div style={{ display: "flex", flexDirection: "column", gap: popoverPadding.standard }}>
                            <Body1 style={{ textAlign: "left" }}>{translate(Content.map3.search_tooltip.save_info_content)}</Body1>
                            <SolidButton style={{ width: "100%" }} onClick={onClose} data-testid="confirm-default-location-info">
                                {Content.map3.search_tooltip.save_info_got_it}
                            </SolidButton>
                        </div>
                    }
                    open
                    onClose={onClose}
                    testId="set-saved-views-tooltip"
                >
                    {children}
                </InfoTooltip>
            );
        }
    }
    return <>{children}</>;
};
